import React from 'react';
import Game from './components/Game';
import './App.css';

function App() {
  return (
    <div className="app-container">
      <Game />
    </div>
  );
}

export default App;